import api from '../../api';

const state = { objects: [], selected: null, loading: false, error: null };

const getters = {
  objects: (state) => state.objects,
  activeObjects: (state) => state.objects.filter((item) => item.status !== 'archived'),
};

const mutations = {
  setObjects(state, objects) { state.objects = objects || []; },
  setSelected(state, object) { state.selected = object; },
  setLoading(state, value) { state.loading = value; },
  setError(state, value) { state.error = value; },
};

const actions = {
  async fetchObjects({ commit }) {
    commit('setLoading', true);
    try {
      const { data } = await api.get('/api/objects');
      commit('setObjects', data.objects || []);
      commit('setError', null);
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Не удалось загрузить объекты');
    } finally { commit('setLoading', false); }
  },
  async createObject({ dispatch }, payload) {
    await api.post('/api/objects', payload);
    await dispatch('fetchObjects');
  },
  async updateObject({ dispatch }, { id, patch }) {
    await api.patch(`/api/objects/${id}`, patch);
    await dispatch('fetchObjects');
  },
  async deleteObject({ dispatch }, id) {
    await api.delete(`/api/objects/${id}`);
    await dispatch('fetchObjects');
  },
};

export default { namespaced: true, state, getters, mutations, actions };
